import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import './index.css';
import App from './App';
import {Provider} from 'react-redux';
import { store } from './store';
import AuthLayout from './layouts/AuthLayout/AuthLayout';
import AgenciesLayout from './layouts/AgenciesLayout/AgenciesLayout';
import FCMLayout from './layouts/FCMLayout/FCMLayout';
import RouteLayout from './layouts/RouteLayout/RouteLayout';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AgencyWarningModalLayout from './layouts/AgencyWarningModalLayou/AgencyWarningModalLayout';
import './utils/i18n'; // Import i18n configuration

const root = ReactDOM.createRoot(document.getElementById('root'));
const siteId = 5314189;
const hotjarVersion = 6;

function loadHotjar(hjid, hjsv) {
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = {hjid: hjid, hjsv: hjsv};
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}

if (import.meta.env.VITE_ENVIRONMENT === 'production') {
  loadHotjar(siteId, hotjarVersion);
}

const queryClient = new QueryClient();

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthLayout>
          <AgenciesLayout>
            <FCMLayout>
              <AgencyWarningModalLayout>
                <RouteLayout>
                  <App />
                </RouteLayout>
              </AgencyWarningModalLayout>
            </FCMLayout>
          </AgenciesLayout>
        </AuthLayout>
      </QueryClientProvider>
    </BrowserRouter>
  </Provider>,
);
